<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-16 13:41:09
 * @LastEditors: yd
 * @LastEditTime: 2020-09-15 17:26:40
--> 
<template>
  <div>
    <v-menu offset-y
            v-model="isShow"
            :disabled='readonly'
            :close-on-content-click='false'>
      <template v-slot:activator="{ on, attrs }">
        <div>
          <!-- v-if="!isShow" -->
          <mrc_ess_input v-bind="attrs"
                         v-on="on"
                         :label="label || $t('label_Email_message')"
                         :readonly='readonly'
                         v-model="defaultemailsubject.content"
                         append-icon="mdi-longitude">
          </mrc_ess_input>
        </div>
      </template>
      <v-list class="bigbox">
        <div class="pl-4"
             style="font-family:var(--body-font-family);color: #0F46C1;font-style: normal;font-weight: 500;font-size: 13px;">
          {{$t('邮件主旨')}}
        </div>
        <v-list-item v-for="(item, index) in childrenpurport"
                     class="mb-0 pb-0"
                     :key="index">
          <mrc_ess_input :label="$t(`label.${item.language_code}`)+'*'"
                         :rules='rules'
                         class="my-0 py-0"
                         @blur="handleinputBlur"
                         :readonly='readonly'
                         v-model="item.content">
          </mrc_ess_input>
          <propertyDialog :readonly='!readonly'
                          :function_uuid='function_uuid'
                          @getpropertylist='getpropertylist($event,index)'></propertyDialog>
        </v-list-item>
        <div class="btnbox"
             v-show="!readonly">
          <mrc_ess_submitBtn @cancel='cancel'
                             @success='success'
                             cancelText='cancel'
                             successText='OK'></mrc_ess_submitBtn>
        </div>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import propertyDialog from './propertyDialog'
export default {
  components: {
    propertyDialog
  },
  props: {
    label: {
      type: String
    },
    purport: {
      type: Array,
      default: () => []
    },
    // defaultemailsubject: {
    //   type: String,
    //   default: '请设置内容'
    // },
    readonly: {
      type: Boolean,
      default: false
    },
    function_uuid: {
      type: String
    },
    // International: {
    //   type: Boolean,
    //   default: true
    // }
  },
  model: {
    prop: 'purport',
    event: 'purportChange'
  },
  data () {
    return {
      rules: [
        value => !!value || 'Required.',
      ],
      isShow: false,
      childrenpurport: [],
      blurIndex: null
    };
  },
  computed: {
    defaultemailsubject () {
      let obj = {
        "language_code": this.$store.state.lang,    //国际化代码
        "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
        "content": ''
      }
      this.childrenpurport.map(item => {
        if (item.language_code.toLowerCase() == this.$store.state.lang.toLowerCase()) {
          obj = {
            "language_code": item.value,    //国际化代码
            "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
            "content": item.content
          }
        }
      })
      return obj
    }
  },
  created () { },
  watch: {
    purport: {
      handler (v) {
        this.childrenpurport = this.$clone(v)
      }, deep: true
    }
  },
  mounted () {
    if (this.$store.state.uuid) {
      this.childrenpurport = this.$clone(this.purport)
    }
    else {
      if (this.$store.state.currentCompanyLanguage && !this.$store.state.currentCompanyLanguage.length > 0) return
      let arr = []
      this.$store.state.currentCompanyLanguage.map(item => {
        arr.push({
          "language_code": item.value,    //国际化代码
          "content_type": "1",    //国际化字段(1:邮件主题  2:邮件内容)
          "content": ''
        })
      })
      this.childrenpurport = this.$clone(arr)
    }
  },

  methods: {
    success () {
      this.isShow = false
      this.$emit('purportChange', this.childrenpurport)
    },
    cancel () {
      this.isShow = false
      this.childrenpurport = this.$clone(this.purport)
    },
    getpropertylist (v, index) {
      v.map(item1 => {
        this.childrenpurport[index].content ? this.childrenpurport[index].content = this.childrenpurport[index].content.slice(0, this.blurIndex) + item1.property + this.childrenpurport[index].content.slice(this.blurIndex) : this.childrenpurport[index].content = item1.property
      })
    },
    handleinputBlur (e) {
      this.blurIndex = e.srcElement.selectionStart
    }
  },
  validations: {

  }
};
</script>

<style scoped>
.bigbox {
  padding: 0;
}
.btnbox /deep/ .btnGroup {
  justify-content: initial;
  flex-direction: row-reverse;
  padding-right: 35px;
}
.bigbox /deep/ .v-list-item {
  display: block;
  margin-bottom: 15px;
}
.bigbox /deep/ .v-.v-messages {
  min-height: 0px;
}
</style>
